// react
import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'

// layouts
import Layout from './layout/layout'

// core-ui------------------------------------------------------------------
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css'
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css'
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css'
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css'
// Import Main styles for this application
import 'assets/scss/style.css'
import Login from 'features/authentication/Login'
import PageNotFound from 'features/errors/page-not-found'
import InternalServerError from 'features/errors/internal-server-error'
// --------------------------------------------------------------------------

class Router extends Component {
  constructor(props) {
    super(props)
    this.state = {
      unmounted: false,
    }
  }

  UNSAFE_componentWillMount() {
    this.setState({ unmounted: false })
  }

  componentWillUnmount() {
    this.setState({ unmounted: true })
  }

  render() {
    return (
      <div>
        <Switch>
          <Route exact path="/login" render={(props) => <Login {...props} />} />
          <Route
            exact
            path="/404"
            render={(props) => <PageNotFound {...props} />}
          />
          <Route
            exact
            path="/500"
            render={(props) => <InternalServerError {...props} />}
          />
          <Route path="/" render={(props) => <Layout {...props} />} />
        </Switch>
      </div>
    )
  }
}

export default Router
